import { Box, Typography } from '@mui/material';
import { brand } from './theme/colors.js';

/**
 * Page header title block shown at the top of each dashboard page.
 * Renders the brand name in red/bold with a dark-gray subtitle beneath it
 * ("Emcure" / "AI Sales Supervisor" per the reference design).
 *
 * @param {Object} props
 * @param {string} [props.brandName='Emcure']
 * @param {string} [props.subtitle='AI Sales Supervisor']
 */
export function PageHeader({ brandName = 'Emcure', subtitle = 'AI Sales Supervisor' }) {
  return (
    <Box sx={{ mb: 3, minWidth: 0 }}>
      <Typography
        component="div"
        sx={{
          color: brand.red,
          fontWeight: 800,
          lineHeight: 1.1,
          // Scale down on narrow screens so the title doesn't overflow.
          fontSize: { xs: '1.3rem', sm: '1.6rem' },
          overflowWrap: 'anywhere',
        }}
      >
        {brandName}
      </Typography>
      <Typography
        sx={{
          color: brand.textSecondary,
          mt: 0.25,
          fontSize: { xs: '0.85rem', sm: '0.95rem' },
          overflowWrap: 'anywhere',
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
}

export default PageHeader;
